import {useRoutes} from "react-router-dom";
import {LoadComponent} from "@loadComponent";
import Layout from "./Layout";
import {lazy} from "react";

const Conference = () => {
    return useRoutes([
        {
            path: '',
            element: <Layout/>,
            children: [
                {
                    path: ':id',
                    element: <LoadComponent component={lazy(() => import('./Room'))}/>,
                }
            ],
        }
    ]);
};


export default Conference;
